import { getCalculationLog as apiLoadCalculationLog } from '../../../rest-api/CalculationLog-api'
import { Dispatch } from 'redux'
import { actionCreatorFactory, AnyAction } from 'typescript-fsa'
import wrapAsyncWorker from '../../../common/wrapAsyncWorker'
import { CalculationLog } from '../../../model/CalculationLog'

const actionCreator = actionCreatorFactory()

export const LoadCalculationLog = actionCreator.async<string, CalculationLog>('LoadCalculationLog')

const loadCalculationLogWorker = wrapAsyncWorker(
  LoadCalculationLog,
  (runIdentifier): Promise<CalculationLog> => apiLoadCalculationLog(runIdentifier)
)

// thunk action creator
export const loadCalculationLog = (runIdentifier: string) => {
  return (dispatch: Dispatch<AnyAction>) => loadCalculationLogWorker(dispatch, runIdentifier)
}
